export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const directions = [
    'Позиция', 'Интересы', 'Аргументация',
    'Влияние', 'Договорённости', 'Результат',
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20conceptual%20illustration%20of%20a%20confident%20leader%20silhouette%20standing%20at%20the%20center%20of%20a%20balanced%20negotiation%20scene%2C%20representing%20business%20interests%20and%20responsibility%2C%20surrounded%20by%20subtle%20geometric%20nodes%20symbolizing%20team%20members%20partners%20and%20stakeholders%20connected%20by%20clean%20lines%20of%20influence%20and%20agreement%2C%20deep%20teal%20and%20emerald%20green%20color%20palette%20with%20warm%20cream%20highlights%2C%20soft%20gradient%20background%2C%20minimalist%20corporate%20art%20style%20with%20calm%20authority%2C%20sense%20of%20responsibility%20and%20constructive%20influence%2C%20elegant%20premium%20editorial%20design%20aesthetic%2C%20generous%20negative%20space%2C%20no%20text%20no%20logos%20no%20branding&width=1920&height=1080&seq=rukovoditel-peregovory-hero-2026&orientation=landscape"
          alt="Руководитель в переговорах — обучение руководителей навыкам переговоров"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-32 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-3xl">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
            Руководитель в переговорах: как влиять, договариваться и отстаивать интересы бизнеса
          </h1>
          <p className="text-sm md:text-lg text-white/85 mb-4 leading-relaxed max-w-xl">
            Развиваем навыки руководителей, которым приходится договариваться с собственниками, сотрудниками, коллегами, клиентами и партнёрами — от сложных рабочих ситуаций до переговоров, влияющих на бизнес-результат.
          </p>
          <p className="text-sm text-white/60 mb-6">
            Корпоративное обучение руководителей в Минске, Беларуси и онлайн.
          </p>

          <div className="flex flex-wrap gap-2 mb-8">
            {directions.map((dir) => (
              <span key={dir} className="bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 px-3 py-1.5 rounded-full text-xs font-medium">
                {dir}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => scrollTo('contact')}
              className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Получить программу
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollTo('contact')}
              className="border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/10 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Обсудить задачу
              <i className="ri-chat-3-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}